import { call, takeLatest } from 'redux-saga/effects';
import config from 'config';

import { pushWithQuery as push } from 'utils/routing';

// @effect Action
const goToShipper$ = 'navigation/goToShipper$';
const goToUser$ = 'navigation/goToUser$';

// @effect action creators

export const goToShipper = ({ shipperId }) => ({
  type: goToShipper$,
  payload: {
    type: 'shipper',
    shipperId,
  },
});

export const goToUser = ({ shipperId, userId }) => ({
  type: goToUser$,
  payload: {
    type: 'shipper_user',
    shipperId,
    userId,
  },
});

// Workers
function* handleNavigation({ payload }) {
  const pagesMap = {
    shipper: ({ shipperId }) => `${config.BASE_ROUTE}shipper/${shipperId}/`,
    shipper_user: ({ shipperId, userId }) =>
      `${config.BASE_ROUTE}shipper/${shipperId}/user/${userId}/`,
  };

  yield call(push, pagesMap[payload.type](payload));
}

// Watchers
export function* watchNavigation() {
  yield takeLatest([goToShipper$, goToUser$], handleNavigation);
}
